import { render, staticRenderFns } from "./activities-add-or-update.vue?vue&type=template&id=c2e13240&scoped=true&"
import script from "./activities-add-or-update.vue?vue&type=script&lang=js&"
export * from "./activities-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./activities-add-or-update.vue?vue&type=style&index=0&id=c2e13240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e13240",
  null
  
)

export default component.exports